module.exports = __webpack_public_path__ + "static/logo-3bd7f1005ae08ca4abecae78a5638449.png";